(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/betslips/reducera.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/betslips/reducera.js');
"use strict";

const {
  useContext
} = React;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  RowsXsmallView,
  RowsView
} = svs.components.tipsen.betslip.views;
const Reducera = () => {
  const {
    isExtraSmall
  } = useContext(BetslipContext);
  if (isExtraSmall) {
    return React.createElement(RowsXsmallView, {
      isReduced: true
    }, "Reducera fritt");
  }
  return React.createElement(RowsView, {
    icon: "free-reduce",
    isReduced: true
  }, React.createElement("span", null, "Reducera fritt"));
};
setGlobal('svs.components.tipsen.betslip.betslips.Reducera', Reducera);

 })(window);